import { useRef } from "react";
import { createPortal } from "react-dom";
import { FiArrowLeft, FiArrowRight, FiX } from "react-icons/fi";
import useBookRevealFocus from "./useBookRevealFocus";
import BookRevealBeam from "./BookRevealBeam";

export default function BookRevealShell({
	children,
	closing,
	reduced,
	onClose,
	position,
	count,
	onPrevious,
	onNext,
}) {
	const root = useRef(null);
	useBookRevealFocus(root, onClose, { position, count: closing ? 0 : count, onPrevious, onNext });
	return createPortal(
		<div
			ref={root}
			role="dialog"
			aria-modal="true"
			aria-label="A closer look"
			aria-describedby="book-reveal-heading"
			tabIndex={-1}
			className={`book-reveal reader-overlay${closing ? " is-closing" : ""}${reduced ? " is-reduced" : ""}`}
		>
			<button
				type="button"
				className="book-reveal-backdrop"
				onClick={onClose}
				tabIndex={-1}
				aria-hidden="true"
			/>
			<BookRevealBeam />
			<header className="book-reveal-header">
				<p className="!bg-transparent text-white"></p>
				<button type="button" onClick={onClose} className="book-reveal-close" aria-label="Close">
					<FiX aria-hidden="true" />
				</button>
			</header>
			<div className="book-reveal-scroll">{children}</div>
			<footer className="book-reveal-footer">
				{count > 1 && (
					<div className="book-reveal-navigation" role="group" aria-label="Browse loaded results">
						<button
							type="button"
							onClick={onPrevious}
							disabled={closing || position === 0}
							aria-label="Previous book"
						>
							<FiArrowLeft aria-hidden="true" />
						</button>
						<span
							aria-live="polite"
							aria-atomic="true"
							aria-label={`Book ${position + 1} of ${count} loaded`}
						>
							{String(position + 1).padStart(2, "0")} <span>/ {count}</span>
						</span>
						<button
							type="button"
							onClick={onNext}
							disabled={closing || position >= count - 1}
							aria-label="Next book"
						>
							<FiArrowRight aria-hidden="true" />
						</button>
					</div>
				)}
				<p>Use arrow keys to browse · Esc to close</p>
			</footer>
		</div>,
		document.body,
	);
}
